module.exports = __webpack_public_path__ + "img/resched-accpt.7cfc4e4d.svg";